import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'music-banner',
    templateUrl: './music.component.html',
    styleUrls: ['./music.component.css'],
    standalone: false
})
export class MusicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
